// Customizable Area Start
export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const PromoIcon = require("../assets/promo.png");
export const loyaltyIcon = require("../assets/loyaltyPoint.png");
export const deamond = require("../assets/deamond.png");
export const label = require("../assets/label.png");
// Customizable Area End
